var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlideback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Slide_back",
    "data-name": "Slide back",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6874",
    "data-name": "Rectangle 6874",
    width: 26,
    height: 26,
    rx: 2,
    fill: "#ecf0fc",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8844",
    "data-name": "Path 8844",
    d: "M152.727,38.017a.722.722,0,0,0,.474-.177l7.25-6.282a.725.725,0,0,0,0-1.1l-7.25-6.285a.725.725,0,0,0-.95,1.1l6.618,5.737-6.618,5.735a.725.725,0,0,0,.475,1.273Z",
    transform: "translate(-141.628 -17.586)",
    fill: "#939393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8845",
    "data-name": "Path 8845",
    d: "M72.725,38.017a.725.725,0,0,0,.725-.725V24.725a.725.725,0,1,0-1.45,0V37.292A.725.725,0,0,0,72.725,38.017Z",
    transform: "translate(-51.96 -17.587)",
    fill: "#939393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8846",
    "data-name": "Path 8846",
    d: "M.725,0A.719.719,0,0,0,0,.714v13.3a.72.72,0,0,0,.725.714.72.72,0,0,0,.725-.714V.714A.719.719,0,0,0,.725,0Z",
    transform: "translate(18.378 12.697) rotate(90)",
    fill: "#939393"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10120",
    "data-name": "Path 10120",
    d: "M.725,0A.725.725,0,0,0,0,.725v13.5a.725.725,0,0,0,1.45,0V.725A.725.725,0,0,0,.725,0Z",
    transform: "translate(18.378 12.697) rotate(90)",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideback);
export default __webpack_public_path__ + "static/media/Slide back.569c442d6acd87bf2eb480974840cbb6.svg";
export { ForwardRef as ReactComponent };